export const MAKE_A_PAYMENT_FEATURE = 'MakeAPayment';
export const CREATE_SALES_ORDER_FEATURE = 'CreateSalesOrder';
export const INTEGRATION_FEEDS_FEATURE = 'IntegrationFeeds';
export const SALES_ORDER_IMPORT_FEATURE = 'SalesOrderImporter';
export const PROMOTIONS_FEATURE = 'Promotions';
